export enum StaticRouteMeta {
  MODEL = "staticroute",
  PK = "id",
}
